// extracted by mini-css-extract-plugin
export default {"container":"HfV0h3HZ","logo":"LXIXMbOS"};